import React from "react";
import {withRouter} from "react-router";
import {DemandValidation} from 'constants/DemandValidation';
import {connect} from "react-redux";
import DocumentsTables from "components/complex/documentsTables/DocumentsTables";
import {DemandValidationProvider} from "context/DemandValidationContext";
import DemandValidationMessages from "components/DemandValidationMessages";
import makeStyles from "@material-ui/core/styles/makeStyles";

const useStyles = makeStyles(theme => ({
    root: {
        width: '100%'
    }
}));

function FinishDocumentsPanel(
    {
        match,
        demandValidation
    }) {

    const classes = useStyles();
    const demandId = match.params.id;

    const currentDemandValidation = DemandValidation.FINISH_DOCUMENTS;
    const section = demandValidation.find(x => x.section === currentDemandValidation);
    const siwzEditable = section ? !!section.siwzEditable : false;
    const repoEditable = section ? !!section.repoEditable : false;

    return (<div className={classes.root}>
            <DemandValidationProvider value={currentDemandValidation}>
                <DemandValidationMessages editable={repoEditable || siwzEditable} section={section}/>
                <DocumentsTables
                    demandId={demandId}
                    siwzEditable={siwzEditable}
                    repoEditable={repoEditable}
                />
            </DemandValidationProvider>

        </div>
    )
}

export default connect((state) => ({
    demandValidation: state.resources.demandValidation
}), {})(withRouter(FinishDocumentsPanel));

